import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'customisationGroup',
    standalone: true
})
export class CustomisationGroupPipe implements PipeTransform {

    transform(items: any, type: string): any[] {
        if (!items) {
            return [];
        }
        const result = [];
        const temp = {};
        items.forEach((item) => {
            if (!item[type]) {
                result.push(item.name);
            } else if (!temp[item[type]]) {
                temp[item[type]] = item.name;
            } else {
                temp[item[type]] += " " + item.name;
            }
        })
        Object.values(temp).forEach((data) => result.push(data));
        return result;
    }

}
